export const TABLE_ID = {
  tableSkeletonPlaceholder: 'tableSkeletonPlaceholder',
  accountTable: 'accountTable',
  eventsDetailsTable: 'eventsDetailsTable',
  eventRsvpsTable: 'eventRsvpsTable',
  eventRsvpsGuests: 'eventRsvpsGuests',
  ipManagementTable: 'ipManagementTable',
  pmcListTable: 'pmcListTable',
  accessPointsTable: 'accessPointsTable',
  NPSTable: 'NPSTable',
  rolesTable: 'rolesTable',
  selectPersonTable: 'selectPersonTable',
  SRSettingsTable: 'SRSettingsTable',
  doorsTable: 'doorsTable',
  cameraTable: 'cameraTable',
  unitTable: 'unitTable',
  accessPointListTable: 'accessPointListTable',
  actionsLogTable: 'actionsLogTable',
  personActionsLogTable: 'personActionsLogTable',
  doorsOpeningLogTable: 'doorsOpeningLogTable',
  deliveriesTable: 'deliveriesTable',
  documentLibraryTable: 'documentLibraryTable',
  aptexxTable: 'aptexxTable',
  brivoTable: 'brivoTable',
  brivoCleanupTable: 'brivoCleanupTable',
  clickpayTable: 'clickpayTable',
  comelitTable: 'comelitTable',
  eeTable: 'eeTable',
  customIntegrationsTable: 'customIntegrationsTable',
  externalPaymentsTable: 'externalPaymentsTable',
  smartairTable: 'smartairTable',
  twoNTable: 'twoNTable',
  akuvoxTable: 'akuvoxTable',
  bmxTable: 'bmxTable',
  dormakabaTable: 'dormakabaTable',
  lyazonTable: 'lyazonTable',
  zervTable: 'zervTable',
  saltoTable: 'saltoTable',
  keyscanTable: 'keyscanTable',
  serviceRequestsTable: 'serviceRequestsTable',
  globalPersonSearchTable: 'globalPersonSearchTable',
  visitorsLogTable: 'visitorsLogTable',
  visitorsTable: 'visitorsTable',
  buildingResidentsTable: 'buildingResidentsTable',
  unitResidentsTable: 'unitResidentsTable',
  buildingStaffTable: 'buildingStaffTable',
  pmcStaffTable: 'pmcStaffTable',
  buildingsTable: 'buildingsTable',
  accessCards: 'accessCards',
  accessCardBatches: 'accessCardBatches',
  residentActivityOverview: 'residentActivityOverview',
  residentLatestActivity: 'residentLatestActivity',
  deliveryTypesManagement: 'deliveryTypesManagement',
  activeVisitors: 'activeVisitors',
  openSR: 'openSR',
  ccVisitors: 'ccVisitors',
  ccResidents: 'ccResidents',
  amenityReservations: 'amenityReservations',
  amenities: 'amenities',
  leasingInquiries: 'leasingInquiries',
  unitActivity: 'unitActivity',
  monthlyBill: 'monthlyBill',
  residentAccessCards: 'residentAccessCards',
  announcements: 'announcements',
  communitySetup: 'communitySetup',
  communityApproval: 'communityApproval',
  communityComments: 'communityComments',
  remoteDoormanCalls: 'remoteDoormanCalls',
  remoteDoormanAgentsLog: 'remoteDoormanAgentsLog',
  remoteDoormanAgentsList: 'remoteDoormanAgentsList',
  remoteDoormanPopUp: 'remoteDoormanPopUp',
  residentNotificationsList: 'residentNotificationsList',
  courierErrorReport: 'courierErrorReport',
  frontDeskVisitors: 'frontDeskVisitors',
  yardiUnits: 'yardiUnits',
  yardiSRCategories: 'yardiSRCategories',
  yardiSRStatuses: 'yardiSRStatuses',
  yardiStatusesOverview: 'yardiStatusesOverview',
  yardiRelationshipsOverview: 'yardiRelationshipsOverview',
};

export const READ_ONLY_ADMIN_ALLOWED_TABLE_IDS = [
  TABLE_ID.pmcListTable,
  TABLE_ID.buildingsTable,
];

export const READ_ONLY_ADMIN_HIDDEN_COLUMNS = [
  'actions',
  'action',
  'monthly_bill',
];

// tables with disabled `columns visibility` functionality
export const HIDDEN_TABLE_IDS = [
  TABLE_ID.tableSkeletonPlaceholder,
  TABLE_ID.NPSTable,
  TABLE_ID.ccVisitors,
  TABLE_ID.ccResidents,
  TABLE_ID.frontDeskVisitors,
  TABLE_ID.yardiUnits,
  TABLE_ID.yardiSRCategories,
  TABLE_ID.yardiSRStatuses,
  TABLE_ID.yardiStatusesOverview,
  TABLE_ID.yardiRelationshipsOverview,
  TABLE_ID.eventRsvpsGuests,
];

const TABLE_SIZE_CONSTANTS = {
  ROW_HEIGHT: 60,
  HEADER_HEIGHT: 50,
};

export const TABLE_ENTRIES_LIMIT = 5000;

export const TABLE_CONSTANTS = {
  name: [
    {
      id: 'name',
    },
  ],
  pmcName: [
    {
      id: 'pmcName',
    },
  ],
  first_name: [
    {
      id: 'first_name',
    },
  ],
  last_name: [
    {
      id: 'last_name',
    },
  ],
  role_name: [
    {
      id: 'role_name',
    },
  ],
  created_at: [
    {
      id: 'created_at',
    },
  ],
  updated_at: [
    {
      id: 'updated_at',
    },
  ],
  building: [
    {
      id: 'building',
    },
  ],
  first_building_name: [
    {
      id: 'first_building_name',
    },
  ],
  latest_call_time: [
    {
      id: 'latest_call_time',
    },
  ],
  admin: [
    {
      id: 'admin',
    },
  ],
  email: [
    {
      id: 'email',
    },
  ],
  phone_number: [
    {
      id: 'phone_number',
    },
  ],
  last_activity_time: [
    {
      id: 'last_activity_time',
    },
  ],
  registered: [
    {
      id: 'registered',
    },
  ],
  has_active_roles: [
    {
      id: 'has_active_roles',
    },
  ],
  role: [
    {
      id: 'role',
    },
  ],
  property: [
    {
      id: 'property',
    },
  ],
  start_datetime: [
    {
      id: 'start_datetime',
    },
  ],
  grandTotal: [
    {
      id: 'grandTotal',
    },
  ],
  starts_at: [
    {
      id: 'starts_at',
    },
  ],
};

export default TABLE_SIZE_CONSTANTS;
